import React from "react";
import Navbar from "./Navbar";

function JingusPage() {
    const openMail = () => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            window.location.href = "mailto:support@jinguslabs.com";
        } else {
            window.open("mailto:support@jinguslabs.com", "_blank");
        }
    };

    return (
        <div
            className="w-full text-[#1d1d1f] bg-white font-['Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif]">
            <Navbar/>

            {/* 1. HERO SECTION */}
            <section className="min-h-[50vh] flex items-center bg-[#f5f5f7]">
                <div
                    className="max-w-[1400px] mx-auto px-8 py-16 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16 items-center">
                    <div>
                        <h1 className="text-[2.4rem] md:text-[3.5xl] lg:text-[4.5rem] leading-[1.1] font-bold tracking-[-0.02em] mb-6 animate-[fadeInUp_1s_ease_forwards]">
                            Where AI Meets
                            <br/>
                            the Unimagined
                        </h1>
                        <p className="text-[1.15rem] md:text-[1.5rem] leading-[1.4] text-[#6e6e73] mb-12 font-normal animate-[fadeInUp_1s_ease_forwards] [animation-delay:0.3s]">
                            Jingu's isn't just building the future—we're inventing it. We
                            create AI and robotics that go beyond expectation.
                        </p>
                    </div>
                    <div
                        className="flex justify-center items-center animate-[fadeInUp_1s_ease_forwards] [animation-delay:0.9s]">
                        <img
                            src="/images/clip-art.png"
                            alt="Jingu's 6-Axis Robotic Arm"
                            className="w-full h-auto max-w-[240px] md:max-w-[600px] animate-[float_6s_infinite_ease-in-out]"
                        />
                    </div>
                </div>
            </section>

            {/* 2. PHILOSOPHY / INTRO */}
            <section className="bg-white">
                <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-14 md:py-32">
                    <div className="max-w-[800px] mx-auto text-center animate-[fadeInUp_1s_ease_forwards]">
                        <p className="text-[1.45rem] md:text-[2rem] leading-[1.45] font-medium text-[#1d1d1f] mb-5">
                            Our systems don't just respond; they anticipate. They don't just
                            compute; they understand. Through relentless innovation, we're
                            turning sci-fi into reality—developing intelligent technology that
                            solves problems before they happen.
                        </p>
                        <p className="text-[1.2rem] md:text-[1.5rem] text-[#0071e3] font-semibold animate-[fadeInUp_1s_ease_forwards] [animation-delay:0.3s]">
                            The future isn't waiting. Neither are we.
                        </p>
                    </div>
                </div>
            </section>

            {/* 3. PRODUCT FEATURE SECTION */}
            <section className="bg-black text-white">
                <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-14 md:py-32">
                    <div className="animate-[fadeInUp_1s_ease_forwards]">
                        <h2 className="text-[2.2rem] md:text-[3.5rem] font-bold mb-3 text-white">
                            Jingu's-js2. Zero Friction.
                        </h2>
                        <p className="text-[1.15rem] md:text-[1.5rem] text-[#e8e8ed] mb-10 md:mb-20 leading-[1.4]">
                            Jingu's JS2. Industrial Robotics Made Simple. 6-Axis Precision
                            Robot. Python Programmable. No expensive teach pendant. No complex
                            setup. Control it directly from your laptop, tablet, or
                            smartphone. Complete robot, software, and control system — all for
                            ₹1.5 Lakhs (taxes extra).
                        </p>
                    </div>

                    <div
                        className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 animate-[fadeInUp_1s_ease_forwards] [animation-delay:0.3s]">
                        <div
                            className="bg-[#1d1d1f] p-8 md:p-12 rounded-[20px] transition-transform duration-300 hover:-translate-y-2.5">
                            <div className="text-base text-[#0071e3] font-bold mb-4">01</div>
                            <h3 className="text-[1.6rem] md:text-[2rem] text-white mb-2">Setup</h3>
                            <h4 className="text-[1.05rem] md:text-[1.2rem] text-[#e8e8ed] mb-4 font-normal">
                                Power On & Connect
                            </h4>
                            <p className="text-[0.95rem] md:text-[1.1rem] text-[#6e6e73] leading-[1.6]">
                                Plug into wall power. The js2 arm broadcasts its own secure,
                                industrial-grade Wi-Fi for immediate local control.
                            </p>
                        </div>

                        <div
                            className="bg-[#1d1d1f] p-8 md:p-12 rounded-[20px] transition-transform duration-300 hover:-translate-y-2.5">
                            <div className="text-base text-[#0071e3] font-bold mb-4">02</div>
                            <h3 className="text-[1.6rem] md:text-[2rem] text-white mb-2">Interface</h3>
                            <h4 className="text-[1.05rem] md:text-[1.2rem] text-[#e8e8ed] mb-4 font-normal">
                                Launch the App
                            </h4>
                            <p className="text-[0.95rem] md:text-[1.1rem] text-[#6e6e73] leading-[1.6]">
                                Scan the QR code on the base. No heavy IDE downloads or bulky
                                teach pendants required.
                            </p>
                        </div>

                        <div
                            className="bg-[#1d1d1f] p-8 md:p-12 rounded-[20px] transition-transform duration-300 hover:-translate-y-2.5">
                            <div className="text-base text-[#0071e3] font-bold mb-4">03</div>
                            <h3 className="text-[1.6rem] md:text-[2rem] text-white mb-2">Execute</h3>
                            <h4 className="text-[1.05rem] md:text-[1.2rem] text-[#e8e8ed] mb-4 font-normal">
                                Write or Jog
                            </h4>
                            <p className="text-[0.95rem] md:text-[1.1rem] text-[#6e6e73] leading-[1.6]">
                                Use an intuitive on-screen joystick or deploy Python scripts for
                                complex automated paths.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4. SPECIFICATIONS SECTION */}
            <section className="bg-white">
                <div
                    className="max-w-[1200px] mx-auto px-5 md:px-8 py-14 md:py-32 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-16 items-center">
                    <div className="animate-[fadeInUp_1s_ease_forwards]">
                        <img
                            src="/images/js2.png"
                            alt="Jingu's Technical Drawing"
                            className="max-w-[240px] md:max-w-[500px] h-auto block mx-auto"
                        />
                    </div>
                    <div
                        className="w-full max-w-full mx-auto px-2 animate-[fadeInUp_1s_ease_forwards] [animation-delay:0.3s]">
                        <h3 className="text-[1.8rem] md:text-[2.5rem] mb-5 font-bold">Technical Specifications</h3>
                        <ul className="list-none border-t border-[#e8e8ed]">
                            <li className="flex flex-row justify-between items-center py-3.5 md:py-6 border-b border-[#e8e8ed] text-[0.9rem] md:text-[1.2rem] gap-4">
                                <strong
                                    className="font-semibold text-[#1d1d1f] text-[0.95rem] md:text-[1.2rem] text-left min-w-[110px]">
                                    Degrees of Freedom
                                </strong>
                                <span className="text-[#6e6e73] text-right text-[0.85rem] md:text-[1.2rem]">
                  6-Axis (Full Articulation)
                </span>
                            </li>
                            <li className="flex flex-row justify-between items-center py-3.5 md:py-6 border-b border-[#e8e8ed] text-[0.9rem] md:text-[1.2rem] gap-4">
                                <strong
                                    className="font-semibold text-[#1d1d1f] text-[0.95rem] md:text-[1.2rem] text-left min-w-[110px]">
                                    Payload Capacity
                                </strong>
                                <span className="text-[#6e6e73] text-right text-[0.85rem] md:text-[1.2rem]">2kg</span>
                            </li>
                            <li className="flex flex-row justify-between items-center py-3.5 md:py-6 border-b border-[#e8e8ed] text-[0.9rem] md:text-[1.2rem] gap-4">
                                <strong
                                    className="font-semibold text-[#1d1d1f] text-[0.95rem] md:text-[1.2rem] text-left min-w-[110px]">Reach</strong>
                                <span
                                    className="text-[#6e6e73] text-right text-[0.85rem] md:text-[1.2rem]">24 inch</span>
                            </li>
                            <li className="flex flex-row justify-between items-center py-3.5 md:py-6 border-b border-[#e8e8ed] text-[0.9rem] md:text-[1.2rem] gap-4">
                                <strong
                                    className="font-semibold text-[#1d1d1f] text-[0.95rem] md:text-[1.2rem] text-left min-w-[110px]">Net
                                    Weight</strong>
                                <span className="text-[#6e6e73] text-right text-[0.85rem] md:text-[1.2rem]">14kg</span>
                            </li>
                        </ul>
                        <p className="mt-6 italic text-[#6e6e73] text-center md:text-left text-[0.85rem] md:text-base">
                            Industrial-grade portability for any workbench.
                        </p>
                    </div>
                </div>
            </section>

            {/* 5. DEMO / CALL TO ACTION */}
            <section className="bg-[#f5f5f7] text-center">
                <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-14 md:py-32">
                    <div className="animate-[fadeInUp_1s_ease_forwards]">
                        <h3 className="text-[2.2rem] md:text-[3.5rem] font-bold mb-3">See Precision in Motion</h3>
                        <p className="text-[1.1rem] md:text-[1.3rem] text-[#6e6e73] max-w-[600px] mx-auto mb-8 leading-[1.6]">
                            Schedule a 1-on-1 live demonstration with our engineering team to
                            see how the Jingu's - js2 integrates into your specific workflow.
                        </p>
                        <div className="flex flex-col items-center gap-6">
                            <button
                                className="inline-block px-7 py-3.5 bg-transparent text-black border-2 border-black rounded-[30px] text-[1rem] md:text-[1.1rem] font-semibold cursor-pointer transition-all duration-200 hover:bg-black hover:text-white"
                                onClick={openMail}
                            >
                                Request a Hardware Walkthrough
                            </button>
                            <ul className="list-none flex flex-col md:flex-row gap-2 md:gap-8 justify-center items-center text-[0.95rem] md:text-[1.1rem] text-[#1d1d1f]">
                                <li>
                                    <span className="text-[#0071e3] font-bold mr-2">✓</span> No-obligation consultation
                                </li>
                                <li>
                                    <span className="text-[#0071e3] font-bold mr-2">✓</span> Python API support
                                </li>
                                <li>
                                    <span className="text-[#0071e3] font-bold mr-2">✓</span> Custom end-effector
                                    consulting
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default JingusPage;